<template>
  <layout>
    <!--城市选择区-->
    <template v-slot:pageLeft>
      <QHleftcity @change="change" @cityLoading="cityLoading" ref="QHleftcity"></QHleftcity>
    </template>
    <!--城市选择区 end-->

    <!--总统计区-->
    <template v-slot:pageTab>
      <div class="headerA flex-center">
        <div class="flex-center-col">
          <font class="fontColor">堆放单位</font>
        </div>
      </div>
      <div class="headerB flex-between">
        <div class="flex-center-y">
          <dl class="item">
            <dt class="bigNumber flex-center-y">
              <div class="danwei">
                <p>{{ dataName }}</p>
                <p>单位数量</p>
              </div>
              <div class="num flex-center">
                <span v-for="(item, index) in $numToArr(total.pageCount || 0)" :key="index">
                  <font>{{ item }}</font>
                </span>
              </div>
              <div class="danwei">个</div>
            </dt>
          </dl>
        </div>
      </div>
    </template>
    <!--总统计区 end-->

    <!--搜索及功能区-->
    <template v-slot:pageSearch>
      <ul class="tab">
        <li style="width: 220px">
          <Input size="small" v-model="searchMap.keyword" placeholder="请输入关键词">
            <Select v-model="searchMap.likeNameA" slot="prepend" style="width: 90px">
              <Option value="name">单位名称</Option>
              <Option value="addressFull">所在地区</Option>
            </Select>
          </Input>
        </li>
        <li>
          <Button type="warning" size="small" @click="search">查询</Button>
        </li>
        <li>
          <Button type="primary" @click="uploadExcel" size="small" >导出公司</Button>
        </li>
      </ul>
    </template>
    <!--搜索及功能区 end-->

    <!--主体呈现区-->
    <template v-slot:pageContent>
      <QHTable :total="total['pageCount'] || 0" :pageThis="pageThis">
        <Table :columns="columns" :data="list" @on-selection-change="(event) => $tableSeletChange(event, pageThis)" :loading="loading" class="QHTableList">
          <!--分割区-->
          <template slot-scope="{ row }" slot="action">
            <Button type="warning" size="small" @click="$goQiyeBigscreen(row.id,7)">详情</Button>
          </template>
        </Table>
      </QHTable>
    </template>
    <!--主体呈现区 end-->

    <!--弹窗组件区-->
    <template v-slot:pageBlock>
      <detailed ref="detailed"></detailed>
    </template>
    <!--弹窗组件区 end-->
  </layout>
</template>
<script>
import detailed from "./block/detailed/detailed";
export default {
  components: {
    detailed,
  },
  data() {
    return {
      //列表配置项(loading加载效果,columns列,list数据,selectedRows选中,total统计项)@@@@@@@@@@@
      list: [],
      loading: false,
      pageThis: this,
      selectedRows: [],
      total: {},
      selectedRowsMore: [],
      columns: this.$colFilter([
        {
          title: "单位名称",
          key: "name",
          className: "hotFont13",
          minWidth: 280,
          ellipsis: true,
          tooltip: true,
          resizable: true,
        },
      
        {
          title: "单位区县",
          key: "districtName",
          align: "center",
          width: 100,
          ellipsis: true,
          tooltip: true,
          resizable: true,
        },
        {
          title: "单位街道",
          key: "streetName",
          align: "center",
          width: 100,
          ellipsis: true,
          tooltip: true,
          resizable: true,
        },
        
        {
          title: "联系姓名",
          width: 100,
          align: "center",
          key: "contactName",
        },
        {
          title: "联系电话",
          width: 110,
          align: "center",
          key: "contactTel",
        },
        {
          title: "开通时间",
          key: "created",
          width: 135,
          align: "center",
          render: (h, parameter) => {
            var row = parameter.row;
            let time = this.$timeFmt(row.created, "YYYY-MM-DD HH:mm");
            return h("span", time);
          },
        },
       
        {
          title: "操作",
          key: "action",
          fixed: "right",
          width: 80,
          slot: "action",
          align: "center",
        },
      ]),

      //搜索配置项@@@@@@@@@@@@@@@@@@@@@@@
      searchMap: {
        likeNameA: "name",
        keyword: "",
        status: 100,
        pageNo: 1,
        pageSize: 25,
        role: "",
      },
      total: {},

      //其他逻辑配置项@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
      dataLoading: false,
      dataName: "",
    };
  },

  // +----------------------------------------------------------------------
  // | mounted
  // +----------------------------------------------------------------------
  mounted() {
    this.$refs.QHleftcity.int();
  },

  methods: {
    // +----------------------------------------------------------------------
    // | 切换数据地址数据
    // +----------------------------------------------------------------------
    change(res) {
      this.searchMap.code = res.code;
      this.searchMap.level = res.level;
      this.dataName = res.name;
      this.dataLoading = false;
    },

    cityLoading(res) {
      this.searchMap.code = res.code;
      this.searchMap.level = res.level;

      this.getList();
    },

    // +----------------------------------------------------------------------
    // | 列表
    // +----------------------------------------------------------------------
    getList() {
      var that = this;
      var https = {
        type: "isPagelist",
        api: this.$api.getOrgduifangList,
        parameter: this.searchMap,
      };
      this.$httpsApi(https, function () {
        that.dataLoading = true;
      });
    },
  // +----------------------------------------------------------------------
        // | 导出excel
        // +----------------------------------------------------------------------
        uploadExcel() {
            this.$loading(true);
            this.searchMap.ids = this.selectedRows;
            var obj1 = this.searchTemp;
            var obj2 = this.searchMap;
        
            this.searchMap = { ...obj2, ...obj1 };
            
            var parameter = this.searchMap;
            var url = "/zxbigscreen/Orgduifang/uploadExcel";
            var fileName = "堆放单位.xlsx";
            this.$downLoad(url,parameter,fileName);
            this.$loading(false);
        },
    // +----------------------------------------------------------------------
    // | 搜索
    // +----------------------------------------------------------------------
    search(status) {
      if (!this.$isblank(status)) {
        this.searchMap.status = status;
      }
      this.getList();
    },
  },
};
</script>
